import { CopyButton, H3, Text, Copy } from 'platform-components/common';
import { HEADER_TEXT_SIZE } from 'platform-components/src/components/constants';
import React from 'react';

import { useRegistrationLinkMetrika, useTeamRegistrationLink } from 'common.components/user/hooks';

import './class__student-link.scss';

export const ClassStudentLink = () => {
    const { ymTeacherLinkCopy } = useRegistrationLinkMetrika();
    const link = useTeamRegistrationLink();
    const linkText = link ? link : '';

    const onInputCopy = () => ymTeacherLinkCopy('my_classes', 'copy_link');
    const onButtonCopy = () => ymTeacherLinkCopy('my_classes', 'list_copy');

    return (
        <div className="class__student-link">
            <H3 id="studentLinkBlock.title" size={HEADER_TEXT_SIZE.XXS} weight={Text.WEIGHT.M} />
            <div className="class__student-link-description">
                <Text id="studentLinkBlock.description" type={Text.TYPE.MARKDOWN} />
            </div>
            <div className="class__student-link-controls">
                <div className="class__student-link-url">
                    <Copy onClick={onInputCopy} text={linkText} />
                </div>
                <div className="class__student-link-button-block">
                    <CopyButton onButtonClick={onButtonCopy} text={linkText} />
                </div>
            </div>
        </div>
    );
};
